/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Nav_Switchlocale1Inputs */

const ja_playdata_nav_switchlocale1 = /** @type {(inputs: Playdata_Nav_Switchlocale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const en_playdata_nav_switchlocale1 = /** @type {(inputs: Playdata_Nav_Switchlocale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日本語`)
};

/**
* | output |
* | --- |
* | "日本語" |
*
* @param {Playdata_Nav_Switchlocale1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_nav_switchlocale1 = /** @type {((inputs?: Playdata_Nav_Switchlocale1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Nav_Switchlocale1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_nav_switchlocale1(inputs)
	return en_playdata_nav_switchlocale1(inputs)
});
export { playdata_nav_switchlocale1 as "playdata_nav_switchLocale" }